export const MIN_NB_OF_SEQUENCES_TO_SHOW_FOLDER_TIP = 3;
